var _circle, _circle2, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgLampsVip = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 600,
    height: 600,
    viewBox: "0 0 600 600",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 300,
    cy: 300,
    r: 290,
    stroke: "#E0399B",
    strokeWidth: 20
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 300,
    cy: 300,
    r: 298,
    stroke: "#FFC83D",
    strokeWidth: 4
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_16886_33595)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 300,
    cy: 12,
    r: 7,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 300,
    cy: 12,
    r: 7,
    fill: "url(#paint0_linear_16886_33595)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 300,
    cy: 12,
    r: 6.5,
    stroke: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_16886_33595)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 300,
    cy: 588,
    r: 7,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 300,
    cy: 588,
    r: 7,
    fill: "url(#paint1_linear_16886_33595)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 300,
    cy: 588,
    r: 6.5,
    stroke: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_16886_33595)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 588,
    cy: 300,
    r: 7,
    transform: "rotate(90 588 300)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 588,
    cy: 300,
    r: 7,
    transform: "rotate(90 588 300)",
    fill: "url(#paint2_linear_16886_33595)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 588,
    cy: 300,
    r: 6.5,
    transform: "rotate(90 588 300)",
    stroke: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_16886_33595)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 300,
    r: 7,
    transform: "rotate(90 12 300)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 300,
    r: 7,
    transform: "rotate(90 12 300)",
    fill: "url(#paint3_linear_16886_33595)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 300,
    r: 6.5,
    transform: "rotate(90 12 300)",
    stroke: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_16886_33595)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 503.646,
    cy: 503.647,
    r: 7,
    transform: "rotate(135 503.646 503.647)",
    fill: "#F5E961"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 503.646,
    cy: 503.647,
    r: 7,
    transform: "rotate(135 503.646 503.647)",
    fill: "url(#paint4_linear_16886_33595)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 503.646,
    cy: 503.647,
    r: 6.5,
    transform: "rotate(135 503.646 503.647)",
    stroke: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_d_16886_33595)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 96.3525,
    cy: 96.3533,
    r: 7,
    transform: "rotate(135 96.3525 96.3533)",
    fill: "#F5E961"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 96.3525,
    cy: 96.3533,
    r: 7,
    transform: "rotate(135 96.3525 96.3533)",
    fill: "url(#paint5_linear_16886_33595)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 96.3525,
    cy: 96.3533,
    r: 6.5,
    transform: "rotate(135 96.3525 96.3533)",
    stroke: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_d_16886_33595)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 96.3535,
    cy: 503.647,
    r: 7,
    transform: "rotate(-135 96.3535 503.647)",
    fill: "#F5E961"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 96.3535,
    cy: 503.647,
    r: 7,
    transform: "rotate(-135 96.3535 503.647)",
    fill: "url(#paint6_linear_16886_33595)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 96.3535,
    cy: 503.647,
    r: 6.5,
    transform: "rotate(-135 96.3535 503.647)",
    stroke: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_d_16886_33595)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 503.647,
    cy: 96.3532,
    r: 7,
    transform: "rotate(-135 503.647 96.3532)",
    fill: "#F5E961"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 503.647,
    cy: 96.3532,
    r: 7,
    transform: "rotate(-135 503.647 96.3532)",
    fill: "url(#paint7_linear_16886_33595)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 503.647,
    cy: 96.3532,
    r: 6.5,
    transform: "rotate(-135 503.647 96.3532)",
    stroke: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_d_16886_33595)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 50.5846,
    cy: 444,
    r: 7,
    transform: "rotate(-120 50.5846 444)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50.5846,
    cy: 444,
    r: 7,
    transform: "rotate(-120 50.5846 444)",
    fill: "url(#paint8_linear_16886_33595)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50.5846,
    cy: 444,
    r: 6.5,
    transform: "rotate(-120 50.5846 444)",
    stroke: "white"
  }))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter9_d_16886_33595)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 549.416,
    cy: 156,
    r: 7,
    transform: "rotate(-120 549.416 156)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 549.416,
    cy: 156,
    r: 7,
    transform: "rotate(-120 549.416 156)",
    fill: "url(#paint9_linear_16886_33595)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 549.416,
    cy: 156,
    r: 6.5,
    transform: "rotate(-120 549.416 156)",
    stroke: "white"
  }))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter10_d_16886_33595)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 21.813,
    cy: 374.54,
    r: 7,
    transform: "rotate(-105 21.813 374.54)",
    fill: "#F5E961"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21.813,
    cy: 374.54,
    r: 7,
    transform: "rotate(-105 21.813 374.54)",
    fill: "url(#paint10_linear_16886_33595)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21.813,
    cy: 374.54,
    r: 6.5,
    transform: "rotate(-105 21.813 374.54)",
    stroke: "white"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter11_d_16886_33595)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 578.186,
    cy: 225.46,
    r: 7,
    transform: "rotate(-105 578.186 225.46)",
    fill: "#F5E961"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 578.186,
    cy: 225.46,
    r: 7,
    transform: "rotate(-105 578.186 225.46)",
    fill: "url(#paint11_linear_16886_33595)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 578.186,
    cy: 225.46,
    r: 6.5,
    transform: "rotate(-105 578.186 225.46)",
    stroke: "white"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter12_d_16886_33595)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 21.8134,
    cy: 225.46,
    r: 7,
    transform: "rotate(-75 21.8134 225.46)",
    fill: "#F5E961"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21.8134,
    cy: 225.46,
    r: 7,
    transform: "rotate(-75 21.8134 225.46)",
    fill: "url(#paint12_linear_16886_33595)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21.8134,
    cy: 225.46,
    r: 6.5,
    transform: "rotate(-75 21.8134 225.46)",
    stroke: "white"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter13_d_16886_33595)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 578.187,
    cy: 374.54,
    r: 7,
    transform: "rotate(-75 578.187 374.54)",
    fill: "#F5E961"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 578.187,
    cy: 374.54,
    r: 7,
    transform: "rotate(-75 578.187 374.54)",
    fill: "url(#paint13_linear_16886_33595)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 578.187,
    cy: 374.54,
    r: 6.5,
    transform: "rotate(-75 578.187 374.54)",
    stroke: "white"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter14_d_16886_33595)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 50.5846,
    cy: 156,
    r: 7,
    transform: "rotate(-60 50.5846 156)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50.5846,
    cy: 156,
    r: 7,
    transform: "rotate(-60 50.5846 156)",
    fill: "url(#paint14_linear_16886_33595)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50.5846,
    cy: 156,
    r: 6.5,
    transform: "rotate(-60 50.5846 156)",
    stroke: "white"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter15_d_16886_33595)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 549.416,
    cy: 444,
    r: 7,
    transform: "rotate(-60 549.416 444)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 549.416,
    cy: 444,
    r: 7,
    transform: "rotate(-60 549.416 444)",
    fill: "url(#paint15_linear_16886_33595)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 549.416,
    cy: 444,
    r: 6.5,
    transform: "rotate(-60 549.416 444)",
    stroke: "white"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter16_d_16886_33595)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 156,
    cy: 50.5846,
    r: 7,
    transform: "rotate(-30 156 50.5846)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 156,
    cy: 50.5846,
    r: 7,
    transform: "rotate(-30 156 50.5846)",
    fill: "url(#paint16_linear_16886_33595)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 156,
    cy: 50.5846,
    r: 6.5,
    transform: "rotate(-30 156 50.5846)",
    stroke: "white"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter17_d_16886_33595)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 444,
    cy: 549.415,
    r: 7,
    transform: "rotate(-30 444 549.415)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 444,
    cy: 549.415,
    r: 7,
    transform: "rotate(-30 444 549.415)",
    fill: "url(#paint17_linear_16886_33595)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 444,
    cy: 549.415,
    r: 6.5,
    transform: "rotate(-30 444 549.415)",
    stroke: "white"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter18_d_16886_33595)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 225.46,
    cy: 21.8133,
    r: 7,
    transform: "rotate(-15 225.46 21.8133)",
    fill: "#F5E961"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 225.46,
    cy: 21.8133,
    r: 7,
    transform: "rotate(-15 225.46 21.8133)",
    fill: "url(#paint18_linear_16886_33595)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 225.46,
    cy: 21.8133,
    r: 6.5,
    transform: "rotate(-15 225.46 21.8133)",
    stroke: "white"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter19_d_16886_33595)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 374.54,
    cy: 578.187,
    r: 7,
    transform: "rotate(-15 374.54 578.187)",
    fill: "#F5E961"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 374.54,
    cy: 578.187,
    r: 7,
    transform: "rotate(-15 374.54 578.187)",
    fill: "url(#paint19_linear_16886_33595)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 374.54,
    cy: 578.187,
    r: 6.5,
    transform: "rotate(-15 374.54 578.187)",
    stroke: "white"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter20_d_16886_33595)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 374.54,
    cy: 21.8133,
    r: 7,
    transform: "rotate(15 374.54 21.8133)",
    fill: "#F5E961"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 374.54,
    cy: 21.8133,
    r: 7,
    transform: "rotate(15 374.54 21.8133)",
    fill: "url(#paint20_linear_16886_33595)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 374.54,
    cy: 21.8133,
    r: 6.5,
    transform: "rotate(15 374.54 21.8133)",
    stroke: "white"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter21_d_16886_33595)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 225.46,
    cy: 578.187,
    r: 7,
    transform: "rotate(15 225.46 578.187)",
    fill: "#F5E961"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 225.46,
    cy: 578.187,
    r: 7,
    transform: "rotate(15 225.46 578.187)",
    fill: "url(#paint21_linear_16886_33595)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 225.46,
    cy: 578.187,
    r: 6.5,
    transform: "rotate(15 225.46 578.187)",
    stroke: "white"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter22_d_16886_33595)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 444,
    cy: 50.5846,
    r: 7,
    transform: "rotate(30 444 50.5846)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 444,
    cy: 50.5846,
    r: 7,
    transform: "rotate(30 444 50.5846)",
    fill: "url(#paint22_linear_16886_33595)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 444,
    cy: 50.5846,
    r: 6.5,
    transform: "rotate(30 444 50.5846)",
    stroke: "white"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter23_d_16886_33595)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 156,
    cy: 549.415,
    r: 7,
    transform: "rotate(30 156 549.415)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 156,
    cy: 549.415,
    r: 7,
    transform: "rotate(30 156 549.415)",
    fill: "url(#paint23_linear_16886_33595)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 156,
    cy: 549.415,
    r: 6.5,
    transform: "rotate(30 156 549.415)",
    stroke: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_16886_33595",
    x: 291,
    y: 5,
    width: 18,
    height: 18,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_16886_33595"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_16886_33595",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_16886_33595",
    x: 291,
    y: 581,
    width: 18,
    height: 18,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_16886_33595"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_16886_33595",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_16886_33595",
    x: 579,
    y: 293,
    width: 18,
    height: 18,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_16886_33595"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_16886_33595",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_16886_33595",
    x: 3,
    y: 293,
    width: 18,
    height: 18,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_16886_33595"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_16886_33595",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_16886_33595",
    x: 494.646,
    y: 496.647,
    width: 18,
    height: 18,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_16886_33595"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_16886_33595",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_d_16886_33595",
    x: 87.3525,
    y: 89.3533,
    width: 18,
    height: 18,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_16886_33595"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_16886_33595",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_d_16886_33595",
    x: 87.3535,
    y: 496.647,
    width: 18,
    height: 18,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_16886_33595"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_16886_33595",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_d_16886_33595",
    x: 494.647,
    y: 89.3531,
    width: 18,
    height: 18,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_16886_33595"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_16886_33595",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_d_16886_33595",
    x: 41.583,
    y: 436.999,
    width: 18.0029,
    height: 18.0023,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_16886_33595"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_16886_33595",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_d_16886_33595",
    x: 540.414,
    y: 148.999,
    width: 18.0029,
    height: 18.0023,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_16886_33595"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_16886_33595",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter10_d_16886_33595",
    x: 12.8115,
    y: 367.538,
    width: 18.0029,
    height: 18.0034,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_16886_33595"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_16886_33595",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter11_d_16886_33595",
    x: 569.185,
    y: 218.458,
    width: 18.0029,
    height: 18.0034,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_16886_33595"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_16886_33595",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter12_d_16886_33595",
    x: 12.8115,
    y: 218.458,
    width: 18.0039,
    height: 18.0035,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_16886_33595"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_16886_33595",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter13_d_16886_33595",
    x: 569.185,
    y: 367.538,
    width: 18.0039,
    height: 18.0035,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_16886_33595"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_16886_33595",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter14_d_16886_33595",
    x: 41.583,
    y: 148.999,
    width: 18.0029,
    height: 18.0023,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_16886_33595"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_16886_33595",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter15_d_16886_33595",
    x: 540.414,
    y: 436.999,
    width: 18.0029,
    height: 18.0023,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_16886_33595"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_16886_33595",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter16_d_16886_33595",
    x: 146.998,
    y: 43.5835,
    width: 18.0029,
    height: 18.0023,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_16886_33595"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_16886_33595",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter17_d_16886_33595",
    x: 434.998,
    y: 542.414,
    width: 18.0029,
    height: 18.0023,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_16886_33595"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_16886_33595",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter18_d_16886_33595",
    x: 216.458,
    y: 14.8115,
    width: 18.0039,
    height: 18.0035,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_16886_33595"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_16886_33595",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter19_d_16886_33595",
    x: 365.538,
    y: 571.185,
    width: 18.0039,
    height: 18.0035,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_16886_33595"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_16886_33595",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter20_d_16886_33595",
    x: 365.538,
    y: 14.8116,
    width: 18.0029,
    height: 18.0034,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_16886_33595"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_16886_33595",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter21_d_16886_33595",
    x: 216.458,
    y: 571.185,
    width: 18.0029,
    height: 18.0035,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_16886_33595"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_16886_33595",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter22_d_16886_33595",
    x: 434.998,
    y: 43.5835,
    width: 18.0029,
    height: 18.0023,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_16886_33595"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_16886_33595",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter23_d_16886_33595",
    x: 146.998,
    y: 542.414,
    width: 18.0029,
    height: 18.0023,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_16886_33595"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_16886_33595",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_16886_33595",
    x1: 300,
    y1: 5,
    x2: 300,
    y2: 19,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC83D",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC83D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_16886_33595",
    x1: 300,
    y1: 581,
    x2: 300,
    y2: 595,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC83D",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC83D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_16886_33595",
    x1: 588,
    y1: 293,
    x2: 588,
    y2: 307,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC83D",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC83D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_16886_33595",
    x1: 12,
    y1: 293,
    x2: 12,
    y2: 307,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC83D",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC83D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_16886_33595",
    x1: 503.646,
    y1: 496.647,
    x2: 503.646,
    y2: 510.647,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D99E2E",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D99E2E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_16886_33595",
    x1: 96.3525,
    y1: 89.3533,
    x2: 96.3525,
    y2: 103.353,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D99E2E",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D99E2E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_16886_33595",
    x1: 96.3535,
    y1: 496.647,
    x2: 96.3535,
    y2: 510.647,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D99E2E",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D99E2E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_16886_33595",
    x1: 503.647,
    y1: 89.3532,
    x2: 503.647,
    y2: 103.353,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D99E2E",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D99E2E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_16886_33595",
    x1: 50.5846,
    y1: 437,
    x2: 50.5846,
    y2: 451,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC83D",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC83D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_16886_33595",
    x1: 549.416,
    y1: 149,
    x2: 549.416,
    y2: 163,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC83D",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC83D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_16886_33595",
    x1: 21.813,
    y1: 367.54,
    x2: 21.813,
    y2: 381.54,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D99E2E",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D99E2E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_16886_33595",
    x1: 578.186,
    y1: 218.46,
    x2: 578.186,
    y2: 232.46,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D99E2E",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D99E2E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_16886_33595",
    x1: 21.8135,
    y1: 218.46,
    x2: 21.8135,
    y2: 232.46,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D99E2E",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D99E2E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_16886_33595",
    x1: 578.187,
    y1: 367.54,
    x2: 578.187,
    y2: 381.54,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D99E2E",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D99E2E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_16886_33595",
    x1: 50.5846,
    y1: 149,
    x2: 50.5846,
    y2: 163,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC83D",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC83D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_16886_33595",
    x1: 549.416,
    y1: 437,
    x2: 549.416,
    y2: 451,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC83D",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC83D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_16886_33595",
    x1: 156,
    y1: 43.5846,
    x2: 156,
    y2: 57.5846,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC83D",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC83D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_16886_33595",
    x1: 444,
    y1: 542.415,
    x2: 444,
    y2: 556.415,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC83D",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC83D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_16886_33595",
    x1: 225.46,
    y1: 14.8133,
    x2: 225.46,
    y2: 28.8133,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D99E2E",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D99E2E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_16886_33595",
    x1: 374.54,
    y1: 571.187,
    x2: 374.54,
    y2: 585.187,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D99E2E",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D99E2E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_16886_33595",
    x1: 374.54,
    y1: 14.8133,
    x2: 374.54,
    y2: 28.8133,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D99E2E",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D99E2E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_16886_33595",
    x1: 225.46,
    y1: 571.187,
    x2: 225.46,
    y2: 585.187,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D99E2E",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D99E2E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_16886_33595",
    x1: 444,
    y1: 43.5846,
    x2: 444,
    y2: 57.5846,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC83D",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC83D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_16886_33595",
    x1: 156,
    y1: 542.415,
    x2: 156,
    y2: 556.415,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC83D",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC83D"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLampsVip);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/lamps-vip.a4812b736302248bf8edf9122b2aaf5c.svg";